import React from "react";
import { getTagBadgeClass } from "../constants/tagColors";

export default function TagBadge({ tag, className = "" }) {
  if (!tag) return null;
  return (
    <span
      className={`inline-flex max-w-full items-center rounded-md px-2 py-1 text-xs font-bold ring-1 ring-inset ${getTagBadgeClass(tag.Couleur)} ${className}`}
      title={tag.Nom}
    >
      <span className="truncate">{tag.Nom}</span>
    </span>
  );
}
